import { Map } from 'immutable';
import {
  CodeMismatchException,
  ExpiredCodeException,
  LimitExceededException,
  MessageRejectedException,
  NotAuthorizedException,
  TooManyFailedAttemptsException,
  UserNotConfirmedException,
} from './cognito/cognito-errors';
import {
  HttpForbiddenException,
  HttpUnauthorizedException,
} from './http/http-errors';
import {
  DuplicateEquipmentSerialException,
  DuplicateFileNameException,
  EquipmentNotFoundException,
  EquipmentSeriesIncompatibleWithTheBusinessException,
  SerialValidationException,
} from './product-service/product-service-errors';
import {
  BusinessEmailAlreadyExists,
  BusinessFrozenException,
  BusinessUnificationAlreadyExistsException,
  BusinessUnificationNeedsMultipleBusinessesException,
  BusinessUnificationNotFromSameCountryException,
  CannotInviteToInactiveBusinessException,
  CouponVIPNotFoundException,
  InvalidHashException,
  RepresentativeLimitReachedException,
} from './user-management-service/user-management-service-errors';
import {
  InputValidationError,
  NotEnoughBalance,
} from './reward-service/reward-service-errors';

const errors = Map({
  'CGN-UNC-001': new UserNotConfirmedException(),
  'CGN-TFA-001': new TooManyFailedAttemptsException(),
  'CGN-NAE-001': new NotAuthorizedException(),
  'CGN-CME–001': new CodeMismatchException(),
  'CGN-ECE-001': new ExpiredCodeException(),
  'CGN-LEE-001': new LimitExceededException(),
  'SES-MRE-001': new MessageRejectedException(),
  'UMS-IHE-001': new InvalidHashException(),
  'UMS-BEN-001': new CannotInviteToInactiveBusinessException(),
  'UMS-DES-001': new DuplicateEquipmentSerialException(),
  'UMS-RLR-001': new RepresentativeLimitReachedException(),
  'UMS-BEE-001': new BusinessEmailAlreadyExists(),
  'UMS-CVN-001': new CouponVIPNotFoundException(),
  'UMS-BFZ-001': new BusinessFrozenException(),
  'UMS-BUE-001': new BusinessUnificationAlreadyExistsException(),
  'UMS-BUE-002': new BusinessUnificationNeedsMultipleBusinessesException(),
  'UMS-BUE-003': new BusinessUnificationNotFromSameCountryException(),
  'GNR-VLE-001': new SerialValidationException(),
  'GNR-IAE-001': new DuplicateFileNameException(),
  'UMS-ENF-001': new EquipmentNotFoundException(),
  'PRD-IES-001': new EquipmentSeriesIncompatibleWithTheBusinessException(),
  'RWD-NEP-001': new NotEnoughBalance(),
  'HTTP-403': new HttpForbiddenException(),
  'HTTP-401': new HttpUnauthorizedException(),
  'GNR-VLE-002': new InputValidationError(),
});

export default errors;
